function getEmbedKeys(state, props) {
  return state.data.embedKeys
}
export function getEmbedKey(state, props) {
  const { timelineId } = props
  const idString = timelineId.toString()
  return getEmbedKeys(state, props)[idString] || null
}
